import DemeritEducationReservationEditForm from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationEditForm';

interface DemeritEducationReservationEditPageProps {
  vin: string;
}

function DemeritEducationReservationEditPage({vin}: DemeritEducationReservationEditPageProps) {
  return <DemeritEducationReservationEditForm vin={vin} />;
}

export default DemeritEducationReservationEditPage;
